import SalesOrdersContainer from '@components/containers/salesOrders';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const SalesOrders: FC = () => (
    <AppLayout>
        <SalesOrdersContainer />
    </AppLayout>
);

export default SalesOrders;
